import React, { Component } from 'react';
import SKYCLockout from 'shared/screens/PurchaseFlow/KYCLockout';
import ImageBW from '../../components/ImageBoundsWrapper';
import { onPressHelp } from 'shared/utils/redirectionHelp';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
export default class KYCLockout extends Component {
  static get AsModalProps() {
    return {
      dialogClassName: 'gtp-modal-kyc-lockout',
    };
  }

  render() {
    return (
      <SKYCLockout
        navigation={this.props.navigation}
        render={({ title, message, buttonLabel }) => {
          return (
            <>
              <div className="header">
                <ImageBW
                  source={assetSource(ASSET_KEY.FULL_MODAL_HEADER)}
                  ibw={require(asset`full-modal-header.ibw`)}
                  style={{ position: 'absolute', width: '100%', height: '100%' }}
                  innerStyle={{}}
                  widthScale={0.5}
                />
                <div className="header-content">
                  <h1 className="title">{title}</h1>
                </div>
              </div>

              <div className="content">
                <img alt="" src={assetSource(ASSET_KEY.MESSAGE_CHAT_BOX)} />

                <p>{message}</p>

                <button className="button-container" onClick={onPressHelp}>
                  <ImageBW
                    source={assetSource(ASSET_KEY.ROUNDED_RECT_PRIMARY)}
                    ibw={require(asset`confirm-button.ibw`)}
                    style={{}}
                    className="button"
                  >
                    <div className="button-content">
                      <span className="button-text" data-label={buttonLabel}>
                        {buttonLabel}
                      </span>
                    </div>
                  </ImageBW>
                </button>
              </div>
            </>
          );
        }}
      />
    );
  }
}
